import { Pipe, PipeTransform } from '@angular/core';
import { SimWithUsage } from '../models/sim';

@Pipe({
  name: 'simAlarmColor'
})
export class SimAlarmColorPipe implements PipeTransform {

  transform(sim: SimWithUsage): string {
    switch (sim.priority) {
      case 1:
        return 'bg-success';
      case 2:
        return 'bg-warning';
      case 3:
        return 'bg-danger';
      default:
        return 'bg-light';
    };
  }

}
